import { matchRoutes } from "react-router-dom";
import { appRouteTree } from "@/routes";

type WithPreload = { preload?: () => Promise<unknown> };

const tryPreload = (value: unknown) => {
  if (!value || typeof value !== "object") return;
  const fn = (value as WithPreload).preload;
  if (typeof fn !== "function") return;
  try {
    fn();
  } catch {
    // best-effort
  }
};

export const preloadByUrl = (url: string): void => {
  if (!url) return;
  const matches = matchRoutes(appRouteTree, url);
  if (!matches) return;
  for (const match of matches) {
    tryPreload((match.route as { Component?: unknown }).Component);
  }
};
